// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchHeader":"LD","sortWrapper":"MD","shortCount":"ND","fullCount":"OD","countWrapper":"PD"};